/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { v4 as uuid } from 'uuid'
import {
  Form,
  Button,
  Row,
  Col,
  Alert,
  Spinner,
  Modal,
  InputGroup,
  ListGroup,
  Card,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleExclamation,
  faDisplay,
  faEdit,
  faLink,
  faTimes,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'
import { ReportList, ReportListSetting } from '../components'
import apiServices from '../services/apiServices'
import { AuthContext, ToastContext } from '../components/ContextProvider'

const labelMap = {
  AD_SERVER_IMPRESSIONS: 'AD SERVER 曝光次數',
  AD_SERVER_CLICKS: 'AD SERVER 點擊次數',
  AD_SERVER_CTR: 'AD SERVER 點閱率',
  AD_SERVER_REVENUE: 'AD SERVER 收益',
  AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS: 'AdX 曝光次數',
  AD_EXCHANGE_LINE_ITEM_LEVEL_CLICKS: 'AdX 點擊次數',
  AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE: 'AdX 收益',
}

const options = {
  impression: {
    'AD_SERVER_IMPRESSIONS(係數)': [
      {
        column: 'AD_SERVER_IMPRESSIONS',
        multipler: 1,
      },
    ],
    'adx imp(係數)': [
      {
        column: 'AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS',
        multipler: 1,
      },
    ],
    'ad server imp(係數)+adx imp(係數)': [
      {
        column: 'AD_SERVER_IMPRESSIONS',
        multipler: 1,
      },
      {
        column: 'AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS',
        multipler: 1,
      },
    ],
  },
  revenue: {
    'ad server (CPM計算)': [
      {
        column: 'AD_SERVER_IMPRESSIONS',
        multipler: 1,
        multiplerName: 'cpm',
      },
    ],
    'adx 收益(係數)': [
      {
        column: 'AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE',
        multipler: 1,
      },
    ],
    'adx 收益(CPM計算)': [
      {
        column: 'AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS',
        multipler: 1,
        multiplerName: 'cpm',
      },
    ],
    'ad server (CPM計算) + adx 收益(係數)': [
      {
        column: 'AD_SERVER_IMPRESSIONS',
        multipler: 1,
        multiplerName: 'cpm',
      },
      {
        column: 'AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE',
        multipler: 1,
      },
    ],
    'ad server (CPM計算) + adx 收益(CPM計算)': [
      {
        column: 'AD_SERVER_IMPRESSIONS',
        multipler: 1,
        multiplerName: 'cpm',
      },
      {
        column: 'AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS',
        multipler: 1,
        multiplerName: 'cpm',
      },
    ],
  },
  click: {
    'AD_SERVER_CLICK(係數)': [
      {
        column: 'AD_SERVER_CLICKS',
        multipler: 1,
      },
    ],
    'adx click(係數)': [
      {
        column: 'AD_EXCHANGE_LINE_ITEM_LEVEL_CLICKS',
        multipler: 1,
      },
    ],
    'ad server click(係數)+adx click(係數)': [
      {
        column: 'AD_SERVER_CLICKS',
        multipler: 1,
      },
      {
        column: 'AD_EXCHANGE_LINE_ITEM_LEVEL_CLICKS',
        multipler: 1,
      },
    ],
  },
}

const custom_date_ranges = {
  LAST_7_DAYS: {
    startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  },
  LAST_14_DAYS: {
    startDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  },
}

function Warn({ setting }) {
  const { size = 'md', show = false, handleClose } = setting

  return (
    <Modal
      style={{ zIndex: '1501' }}
      size={size}
      show={show !== false}
      onHide={() => handleClose(false)}
    >
      <Modal.Header
        className="AccFormModal justify-content-center text-center pt-4"
        closeButton
      >
        <Modal.Title>
          <h4>系統訊息</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex AccformCard">
        <div className="assPermis w-100">
          <Form className="px-2 Form-card flex-grow-1">
            <Form.Group className="px-5 lh-md text-center text-dai">
              <FontAwesomeIcon
                icon={faCircleExclamation}
                style={{ height: '5rem' }}
                className="my-4"
              />
              <Form.Label className="w-100 fs-5 fw-bold text-center pb-4">
                確定要刪除嗎？
              </Form.Label>
            </Form.Group>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className="sendForm justify-content-center py-3">
        <Button variant="secondary" onClick={() => handleClose(false)}>
          取消
        </Button>
        <Button variant="dai" onClick={() => handleClose(show)}>
          確定
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

function Conditions({ setting }) {
  const {
    field,
    handleChange,
    customDimensionKeyIds,
    dimensions,
    adunits,
    lineItems,
  } = setting

  const { filters } = field
  const setFilters = (newValue) =>
    handleChange({
      filters: newValue,
    })
  // const [filters, setFilters] = useState(setting.filters || [])
  // useEffect(() => {
  //   if (setting.filters) setFilters(setting.filters || [])
  // }, [setting.filters])

  const addFilter = () =>
    setFilters([...filters, { id: uuid(), dimId: '', mode: 'IN', values: [] }])

  const updateFilter = (id, patch) =>
    setFilters(filters.map((f) => (f.id === id ? { ...f, ...patch } : f)))

  const removeFilter = (id) => setFilters(filters.filter((f) => f.id !== id))

  return (
    <>
      <Row>
        <Col />
        <Col xs={1}>
          {!field.hasFilter && (
            <Form.Check
              label="啟用"
              name={field.label}
              checked={field.active}
              onChange={() => handleChange({ active: !field.active })}
            />
          )}
        </Col>
        {field.label === 'click' && (
          <Col xs={2}>
            <Form.Check
              type="switch"
              label="啟用點擊率"
              name="click_rate"
              checked={field.useRate && field.active}
              disabled={!field.active}
              onChange={() => handleChange({ useRate: !field.useRate })}
            />
          </Col>
        )}
      </Row>
      <Row className="mb-2">
        <Col xs={3} className="d-flex">
          <Form.Label className="my-auto">計算方式</Form.Label>
        </Col>
        <Col>
          <Form.Select
            disabled={!field.active}
            value={field.option}
            onChange={(e) => {
              handleChange({
                depend: options[field.label][e.target.value],
                option: e.target.value,
              })
            }}
          >
            {Object.keys(options[field.label]).map((key) => (
              <option key={key} value={key}>
                {key}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      {field.depend.map((d) => (
        <Row key={d.column} className="mb-2">
          <Col xs={6} className="d-flex">
            <Form.Label className="my-auto">
              {labelMap[d.column]} {d.multiplerName || '係數'}
            </Form.Label>
          </Col>
          <Col>
            <Form.Control
              name={d.column}
              value={d.multipler}
              onChange={(e) => {
                handleChange({
                  depend: field.depend.map((fd) =>
                    fd.column === d.column
                      ? {
                          ...fd,
                          multipler: e.target.value,
                        }
                      : fd
                  ),
                })
              }}
              disabled={!field.active}
            />
          </Col>
        </Row>
      ))}
      {field.hasFilter && (
        <>
          <Button
            variant="outline-primary"
            className="mx-1"
            size="sm"
            onClick={addFilter}
          >
            ➕ 新增 Filter
          </Button>

          {filters.map((flt) => {
            // 依選到的 dimId 動態抓可選值
            const isCustom = flt.dimId.startsWith('CUSTOM_DIMENSION_')
            const dimKey = isCustom
              ? flt.dimId.replace('CUSTOM_DIMENSION_', '')
              : flt.dimId

            const valueOptions = flt.dimId
              ? isCustom
                ? dimensions.find((d) => d.id === dimKey)?.values ?? []
                : flt.dimId === 'AD_UNIT_ID'
                ? adunits
                : lineItems
              : []
            return (
              <Row
                key={flt.id}
                className="text-start border rounded overflow-hidden mx-1 my-2 p-2"
                style={{
                  height: '200px',
                }}
              >
                {/* 維度選單 */}
                <Col xs={3}>
                  <Form.Select
                    value={flt.dimId}
                    onChange={(e) =>
                      updateFilter(flt.id, {
                        dimId: e.target.value,
                        values: [],
                      })
                    }
                  >
                    <option value="">-- 選擇維度 --</option>
                    {customDimensionKeyIds.map((id) => (
                      <option key={id} value={`CUSTOM_DIMENSION_${id}`}>
                        {dimensions.find((d) => d.id === id)?.displayName}
                      </option>
                    ))}
                    <option value="AD_UNIT_ID">廣告單元</option>
                    <option value="LINE_ITEM_ID">委刊項</option>
                  </Form.Select>
                </Col>
                {/* 條件選單 */}
                <Col xs={2}>
                  <Form.Select
                    value={flt.mode}
                    onChange={(e) =>
                      updateFilter(flt.id, { mode: e.target.value })
                    }
                  >
                    <option value="IN">包含</option>
                    <option value="NOT IN">不包含</option>
                  </Form.Select>
                </Col>
                {/* 值選單 (multi) */}
                <Col xs={5} className="overflow-auto h-100">
                  {valueOptions.map((val) => (
                    <Row key={val.name}>
                      <Col xs={1}>
                        <Form.Check
                          checked={flt.values.includes(val.name)}
                          onChange={() =>
                            updateFilter(flt.id, {
                              values: flt.values.includes(val.name)
                                ? flt.values.filter((v) => v !== val.name)
                                : [...flt.values, val.name],
                            })
                          }
                        />
                      </Col>
                      <Col>{`${val.displayName}${
                        val.adTagName ? `- ${val.adTagName}` : ''
                      }`}</Col>
                    </Row>
                  ))}
                </Col>
                {/* 刪除按鈕 */}
                <Col xs={2}>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeFilter(flt.id)}
                  >
                    刪除
                  </Button>
                </Col>
              </Row>
            )
          })}
        </>
      )}
    </>
  )
}

function AdManagerReportForm() {
  const { setToast } = useContext(ToastContext)
  const { auth } = useContext(AuthContext)

  const [form, setForm] = useState({
    dimensions: ['AD_UNIT_ID', 'DATE', 'CUSTOM_DIMENSION'],
    columns: [
      'AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS',
      'AD_EXCHANGE_LINE_ITEM_LEVEL_CLICKS',
      'AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE',
    ],
    customDimensionKeyIds: ['13107349'],
    customDimensionKeyValues: [],
    dateRangeType: 'LAST_MONTH',
    filterStatement: '',
    startDate: '',
    endDate: '',
    currencyRate: 0,
    extraFields: [
      {
        label: 'impression',
        depend: options.impression['AD_SERVER_IMPRESSIONS(係數)'],
        active: true,
      },
      {
        label: 'revenue',
        depend: options.revenue['ad server (CPM計算)'],
        active: true,
      },
      {
        label: 'click',
        depend: options.click['AD_SERVER_CLICK(係數)'],
        active: true,
        useRate: true,
      },
    ],
  })

  const [filters, setFilters] = useState(form.filters || [])
  useEffect(() => {
    if (form.filters) setFilters(form.filters || [])
  }, [form.filters])

  const addFilter = () =>
    setFilters([...filters, { id: uuid(), dimId: '', mode: 'IN', values: [] }])

  const updateFilter = (id, patch) =>
    setFilters(filters.map((f) => (f.id === id ? { ...f, ...patch } : f)))

  const removeFilter = (id) => setFilters(filters.filter((f) => f.id !== id))

  const [currencyTable, setcurrencyTable] = useState([])
  const getCurrency = async () => {
    const res = await apiServices.data({
      path: 'report/rate',
      method: 'get',
    })
    setcurrencyTable(res)
  }
  useEffect(() => {
    getCurrency()
  }, [])

  const [linkId, setLinkId] = useState('')
  const [links, setlinks] = useState([])
  const getLinks = async () => {
    const res = await apiServices.data({
      path: 'report/link',
      method: 'get',
    })
    console.log('getLinks - res', res)
    setlinks(res)
  }
  useEffect(() => {
    getLinks()
  }, [])
  console.log('getLinks - links:', links)

  useEffect(() => {
    if (linkId) {
      const linkForm = links.find((link) => link.report_id === linkId).setting
        .form
      const ex = linkForm.extraFields
      console.log(
        'useEffect - original linkForm.dimensions: ',
        linkForm.dimensions
      )
      setForm({
        ...form,
        ...linkForm,
        // customDimensionKeyIds: ['13107349'],
        dimensions: Array.from(
          new Set([...linkForm.dimensions, 'CUSTOM_DIMENSION'])
        ),
        extraFields: ex
          ? [
              {
                label: 'impression',
                depend: options.impression['AD_SERVER_IMPRESSIONS(係數)'],
                active: true,
                ...(ex[0] || {}),
              },
              {
                label: 'revenue',
                depend: options.revenue['ad server (CPM計算)'],
                active: true,
                ...(ex[1] || {}),
              },
              {
                label: 'click',
                depend: options.click['AD_SERVER_CLICK(係數)'],
                active: true,
                useRate: true,
                ...(ex[2] || {}),
              },
            ]
          : [
              {
                label: 'impression',
                depend: options.impression['AD_SERVER_IMPRESSIONS(係數)'],
                active: true,
              },
              {
                label: 'revenue',
                depend: options.revenue['ad server (CPM計算)'],
                active: true,
              },
              {
                label: 'click',
                depend: options.click['AD_SERVER_CLICK(係數)'],
                active: true,
                useRate: true,
              },
            ],
      })
    }
  }, [linkId])

  const handleAddLink = async () => {
    await apiServices.data({
      path: 'report/link',
      method: 'post',
      data: {
        name: '未命名',
        form,
        mockups: [],
      },
    })
    getLinks()
  }

  const handleDeleteLink = async (id) => {
    await apiServices.data({
      path: `report/link/${id}`,
      method: 'delete',
    })
    getLinks()
  }

  const handleEditLink = async (id, value) => {
    await apiServices.data({
      path: `report/link/${id}`,
      method: 'put',
      data: value,
    })
    getLinks()
  }

  const [search, setSearch] = useState('')
  const filtered = links.filter((link) => {
    const name = link.setting?.form?.name
    if (!name) return true // 新增表單時還沒有 name，也必須顯示
    return name.includes(search)
  })

  const [showWarn, setshowWarn] = useState({
    show: false,
    func: () => {},
  })

  const [showsetting, setshowsetting] = useState(1)

  const [dimensions, setdimensions] = useState([])
  const [adunits, setadunits] = useState([])
  const getDimensions = async () => {
    const res = await apiServices.data({
      path: 'report/customdimensions',
      method: 'get',
    })
    const customFieldsRes = await apiServices.data({
      path: 'report/line-item-custom-fields',
      method: 'get',
    })
    console.log('customdimensions', res)
    console.log('customFieldsRes', customFieldsRes)
    setdimensions(res.concat(customFieldsRes))
  }

  const getAdunits = async () => {
    const res = await apiServices.data({
      path: 'report/dimensions',
      method: 'get',
    })
    setadunits(res.adunits)
  }
  useEffect(() => {
    getDimensions()
    getAdunits()
  }, [])
  console.log('dimensions:', dimensions)
  console.log('adunits:', adunits)

  const [response, setResponse] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [reportStatus, setReportStatus] = useState(null)
  const [downloadUrl, setDownloadUrl] = useState(null)
  const [records, setRecords] = useState(null)

  const lineItems = useMemo(() => {
    if (!records || !records.find((r) => r['Dimension.LINE_ITEM_NAME'])) {
      return []
    }
    return Array.from(
      new Set(records.map((r) => r['Dimension.LINE_ITEM_NAME']))
    ).map((r) => ({
      displayName: r,
      name: r,
      value: r,
    }))
  }, [records])

  const handleChange = (e) => {
    const { name, value } = e.target
    setForm({ ...form, [name]: value })
  }
  console.log(form)

  const handleMultiSelectChange = (e) => {
    console.log(
      'handleMultiSelectChange - current form.customDimensionKeyIds: ',
      form.customDimensionKeyIds
    )
    const { name, value } = e.target
    console.log('handleMultiSelectChange - value', value)
    if (value.includes('CUSTOM_DIMENSION_')) {
      console.log('handleMultiSelectChange - CUSTOM_DIMENSION_', value)
      const id = value.replace('CUSTOM_DIMENSION_', '')
      const updated = form.customDimensionKeyIds.includes(id)
        ? form.customDimensionKeyIds.filter((f) => f !== id)
        : [...form.customDimensionKeyIds, id]
      console.log(
        'handleMultiSelectChange - updated customDimensionKeyIds: ',
        updated
      )
      setForm({ ...form, customDimensionKeyIds: updated })
    } else {
      console.log(form[name])
      const updated = form[name].includes(value)
        ? form[name].filter((f) => f !== value)
        : [...form[name], value]
      setForm({ ...form, [name]: updated })
    }
  }

  const checkReportStatus = async (reportId) => {
    const interval = setInterval(async () => {
      try {
        const statusRes = await apiServices.data({
          path: `report/status/${reportId}`,
          method: 'get',
        })
        // const statusRes = await axios.get(`/report/status/${reportId}`)
        setReportStatus(statusRes.status)
        if (statusRes.status === 'COMPLETED') {
          clearInterval(interval)
          setDownloadUrl(statusRes.downloadUrl)
          setRecords(statusRes.records)
          setshowsetting(2)
          setLoading(false)
        } else if (statusRes.status === 'FAILED') {
          clearInterval(interval)
          setError('報表產生失敗')
          setLoading(false)
        }
      } catch (err) {
        clearInterval(interval)
        setError('輪詢報表狀態時出錯')
        setLoading(false)
      }
    }, 3000)
  }

  const convertDateToObject = (dateStr) => {
    const [year, month, day] = dateStr.split('-').map(Number)
    return { year, month, day }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    await handleEditLink(linkId, {
      ...links.find((link) => link.report_id === linkId).setting,
      form: {
        ...form,
        filters,
      },
    })

    setError(null)
    setResponse(null)
    setReportStatus(null)
    setDownloadUrl(null)
    setLoading(true)
    try {
      const replaceColumns = form.extraFields.reduce(
        (prev, cur) => [...prev, ...cur.depend.map((d) => d.column)],
        []
      )

      console.log(
        'handleSubmit - form.customDimensionKeyIds',
        form.customDimensionKeyIds
      )
      console.log('handleSubmit - dimensions', dimensions)

      // customDimensionKeyIds 裡面包含 custom targeting key 和 custom field
      // 一開始有從後端 fetch 兩種資料，最後都合併到 `dimensions` state 中
      const targetingKeyIds = []
      const customFieldIds = []
      form.customDimensionKeyIds.forEach((id) => {
        if (
          dimensions
            .filter((d) => d.id === id)[0]
            .name.includes('customTargetingKeys')
        ) {
          targetingKeyIds.push(id)
        } else {
          customFieldIds.push(id)
        }
      })
      console.log('handleSubmit - targetingKeyIds: ', targetingKeyIds)
      console.log('handleSubmit - customFieldIds: ', customFieldIds)

      const reportQuery = {
        dimensions: targetingKeyIds.length
          ? form.dimensions
          : form.dimensions.filter((f) => f !== 'CUSTOM_DIMENSION'),
        columns: Array.from(new Set(form.columns.concat(replaceColumns))),
        customDimensionKeyIds: targetingKeyIds,
        customFieldIds,
        dateRangeType: custom_date_ranges[form.dateRangeType]
          ? 'CUSTOM_DATE'
          : form.dateRangeType,
        statement: form.filterStatement
          ? { query: form.filterStatement }
          : undefined,
        reportCurrency: 'USD',
        timeZoneType: 'PUBLISHER',
      }
      if (
        form.dateRangeType === 'CUSTOM_DATE' ||
        custom_date_ranges[form.dateRangeType]
      ) {
        reportQuery.startDate = convertDateToObject(
          custom_date_ranges[form.dateRangeType]?.startDate || form.startDate
        )
        reportQuery.endDate = convertDateToObject(
          custom_date_ranges[form.dateRangeType]?.endDate || form.endDate
        )
      }
      const res = await apiServices.data({
        path: `report`,
        method: 'post',
        data: reportQuery,
      })
      setResponse(res)
      checkReportStatus(res.id)
    } catch (err) {
      setError(err.message)
      setLoading(false)
    }
  }

  // const checkCustomKey = (row, customDimensionKeyValues) => {
  //   console.log(row)
  //   const site = row['Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[13107349]_VALUE']
  //   if (!customDimensionKeyValues.length) return true
  //   return customDimensionKeyValues.includes(site)
  // }

  const checkFilters = (row) => {
    if (!filters.length) return true

    return filters.every((flt) => {
      // 無維度 / 無值 → 略過此條件
      if (!flt.dimId || !flt.values.length) return true

      let fieldKey = ''
      let cellVal = ''

      if (flt.dimId === 'AD_UNIT_ID') {
        fieldKey = 'Dimension.AD_UNIT_ID'
        cellVal = String(row[fieldKey] ?? '')
      } else {
        // CUSTOM_DIMENSION_<id>
        const id = flt.dimId.replace('CUSTOM_DIMENSION_', '')

        const dimension = dimensions.find((dim) => dim.id === id)

        if (dimension) {
          if (dimension.name.includes('customTargetingKeys')) {
            fieldKey = `Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[${id}]_ID`
          } else if (dimension.name.includes('customFields')) {
            fieldKey = `CF[${id}]_Value`
          } else {
            fieldKey = `Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[${id}]_ID`
          }
        } else {
          fieldKey = `Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[${id}]_ID`
        }

        cellVal = String(row[fieldKey] ?? '')
      }

      // 比對結果 (全部轉字串比較，省去型別差異)
      const hit = flt.values.map((v) => v.split('/').pop()).includes(cellVal)

      return flt.mode === 'IN' ? hit : !hit // IN → 必須命中；NOT IN → 必須不命中
    })
  }

  const dateRangeTypes = [
    'LAST_7_DAYS',
    'LAST_14_DAYS',
    'TODAY',
    'YESTERDAY',
    'LAST_WEEK',
    'LAST_MONTH',
    'LAST_3_MONTHS',
    'REACH_LIFETIME',
    'CUSTOM_DATE',
    'NEXT_DAY',
    'NEXT_90_DAYS',
    'NEXT_WEEK',
    'NEXT_MONTH',
    'CURRENT_AND_NEXT_MONTH',
    'NEXT_QUARTER',
    'NEXT_3_MONTHS',
    'NEXT_12_MONTHS',
  ]

  return linkId ? (
    <div className="px-5 h-100">
      {showsetting === 1 && auth.authed ? (
        <Form
          onSubmit={handleSubmit}
          className="p-4 h-100 d-flex flex-column overflow-scroll"
        >
          <h4>Google Ad Manager Report Builder</h4>
          <Form.Group className="mb-3">
            <Form.Label>報表名稱</Form.Label>
            <Form.Control
              name="name"
              value={form.name}
              onChange={handleChange}
            />
            <Form.Label>Date Range</Form.Label>
            <Form.Select
              name="dateRangeType"
              value={form.dateRangeType}
              onChange={handleChange}
            >
              {dateRangeTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {form.dateRangeType === 'CUSTOM_DATE' && (
            <Row className="mb-3">
              <Col>
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  name="startDate"
                  value={form.startDate}
                  onChange={handleChange}
                />
              </Col>
              <Col>
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  name="endDate"
                  value={form.endDate}
                  onChange={handleChange}
                />
              </Col>
            </Row>
          )}

          <Row
            className="mb-3 px-1"
            style={{
              minHeight: '30vh',
            }}
          >
            <Col className="h-100">
              <Form.Group className="h-100 d-flex flex-column">
                <Form.Label>Dimensions</Form.Label>
                <Form.Select
                  multiple
                  name="dimensions"
                  className="flex-fill"
                  value={form.dimensions.concat(
                    form.customDimensionKeyIds.map(
                      (id) => `CUSTOM_DIMENSION_${id}`
                    )
                  )}
                  onChange={handleMultiSelectChange}
                  style={{ overflowY: 'auto' }}
                >
                  {dimensions.map((dimension) => (
                    <option
                      key={dimension.id}
                      value={`CUSTOM_DIMENSION_${dimension.id}`}
                    >
                      {dimension.displayName}
                    </option>
                  ))}
                  <option value="AD_UNIT_ID">AD_UNIT_ID</option>
                  <option value="DATE">DATE</option>
                  <option value="LINE_ITEM_ID">LINE_ITEM_ID</option>
                  <option value="LINE_ITEM_NAME">LINE_ITEM_NAME</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col className="h-100">
              <Form.Group className="h-100 d-flex flex-column">
                <Form.Label>Columns (Metrics)</Form.Label>
                <Form.Select
                  multiple
                  name="columns"
                  className="flex-fill"
                  value={form.columns}
                  onChange={handleMultiSelectChange}
                  style={{ overflowY: 'auto' }}
                >
                  <option value="AD_SERVER_IMPRESSIONS">
                    AD_SERVER_IMPRESSIONS
                  </option>
                  <option value="AD_SERVER_CLICKS">AD_SERVER_CLICKS</option>
                  <option value="AD_SERVER_CTR">AD_SERVER_CTR</option>
                  <option value="AD_SERVER_REVENUE">AD_SERVER_REVENUE</option>
                  <option value="AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS">
                    AD_EXCHANGE_IMPRESSIONS
                  </option>
                  <option value="AD_EXCHANGE_LINE_ITEM_LEVEL_CLICKS">
                    AD_EXCHANGE_CLICKS
                  </option>
                  <option value="AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE">
                    AD_EXCHANGE_REVENUE
                  </option>
                  <option value="AD_EXCHANGE_TOTAL_REQUESTS">
                    AD_EXCHANGE_TOTAL_REQUESTS
                  </option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-2">
            <Col className="d-flex py-3" xs={8}>
              {response && !reportStatus && (
                <Alert variant="info" className="my-auto w-100">
                  🧾 報表建立中... ReportJob ID: {response.id}
                </Alert>
              )}

              {reportStatus && reportStatus !== 'COMPLETED' && (
                <Alert variant="warning" className="my-auto w-100">
                  ⏳ 報表狀態：{reportStatus}
                </Alert>
              )}

              {error && (
                <Alert variant="danger" className="my-auto w-100">
                  ❌ 錯誤：{error}
                </Alert>
              )}
            </Col>
            <Col xs={3} className="ms-1 text-nowrap d-flex">
              <Button
                className="me-3 my-auto"
                variant="secondary"
                onClick={() => setLinkId('')}
                disabled={loading}
              >
                返回列表
              </Button>

              <Button className="my-auto" type="submit" disabled={loading}>
                {loading ? '執行中...' : '取得數據並進行下一步設定'}
              </Button>
            </Col>
          </Row>
        </Form>
      ) : showsetting === 2 ? (
        <div className="overflow-scroll p-3 h-100">
          {!(downloadUrl && records) && (
            <div className="d-flex h-100 justify-content-center">
              <Spinner
                className="my-auto"
                animation="border"
                size="sm"
                style={{
                  animation: 'spinner-border 1.5s linear infinite',
                }}
              />
              <h5 className="text-dai fs-4 my-auto ms-2">資料載入中...</h5>
            </div>
          )}
          <Row>
            <h4>進階設定</h4>
          </Row>
          <Row className="px-3">
            <Card className="px-0 mt-2">
              <Card.Header>Filter</Card.Header>
              <Card>
                <Button
                  variant="outline-primary"
                  className="mx-1"
                  size="sm"
                  onClick={addFilter}
                >
                  ➕ 新增 Filter
                </Button>

                {filters.map((flt) => {
                  // 依選到的 dimId 動態抓可選值
                  const isCustom = flt.dimId.startsWith('CUSTOM_DIMENSION_')
                  const dimKey = isCustom
                    ? flt.dimId.replace('CUSTOM_DIMENSION_', '')
                    : flt.dimId

                  const valueOptions = flt.dimId
                    ? isCustom
                      ? dimensions.find((d) => d.id === dimKey)?.values ?? []
                      : flt.dimId === 'AD_UNIT_ID'
                      ? adunits
                      : lineItems
                    : []
                  return (
                    <Row
                      key={flt.id}
                      className="text-start border rounded overflow-hidden mx-1 my-2 p-2"
                      style={{
                        minHeight: '20vh',
                        maxHeight: '20vh',
                      }}
                    >
                      {/* 維度選單 */}
                      <Col xs={3}>
                        <Form.Select
                          value={flt.dimId}
                          onChange={(e) =>
                            updateFilter(flt.id, {
                              dimId: e.target.value,
                              values: [],
                            })
                          }
                        >
                          <option value="">-- 選擇維度 --</option>
                          {form.customDimensionKeyIds.map((id) => (
                            <option key={id} value={`CUSTOM_DIMENSION_${id}`}>
                              {dimensions.find((d) => d.id === id)?.displayName}
                            </option>
                          ))}
                          <option value="AD_UNIT_ID">廣告單元</option>
                          <option value="LINE_ITEM_ID">委刊項</option>
                        </Form.Select>
                      </Col>
                      {/* 條件選單 */}
                      <Col xs={2}>
                        <Form.Select
                          value={flt.mode}
                          onChange={(e) =>
                            updateFilter(flt.id, { mode: e.target.value })
                          }
                        >
                          <option value="IN">包含</option>
                          <option value="NOT IN">不包含</option>
                        </Form.Select>
                      </Col>
                      {/* 值選單 (multi) */}
                      <Col xs={5} className="overflow-auto h-100">
                        {valueOptions.map((val) => (
                          <Row key={val.name}>
                            <Col xs={1}>
                              <Form.Check
                                checked={flt.values.includes(val.name)}
                                onChange={() =>
                                  updateFilter(flt.id, {
                                    values: flt.values.includes(val.name)
                                      ? flt.values.filter((v) => v !== val.name)
                                      : [...flt.values, val.name],
                                  })
                                }
                              />
                            </Col>
                            <Col>{`${val.displayName} - ${val.adTagName}`}</Col>
                          </Row>
                        ))}
                      </Col>
                      {/* 刪除按鈕 */}
                      <Col xs={2}>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => removeFilter(flt.id)}
                        >
                          刪除
                        </Button>
                      </Col>
                    </Row>
                  )
                })}
              </Card>
            </Card>
          </Row>
          <Row className="px-3">
            <Card className="px-0 mt-2">
              <Card.Header>美金匯率</Card.Header>
              <Card>
                <Form.Control
                  type="number"
                  placeholder={`未設定匯率，現在使用預設匯率：${currencyTable[0].value}`}
                  onChange={(e) =>
                    setForm({
                      ...form,
                      currencyRate: e.target.value,
                    })
                  }
                />
              </Card>
            </Card>
          </Row>
          <Row className="px-3">
            {form.extraFields.map((field) => (
              <Card className="px-0 mt-2">
                <Card.Header>{field.label}</Card.Header>
                <Card.Body>
                  <Conditions
                    setting={{
                      field,
                      handleChange: (value) =>
                        setForm({
                          ...form,
                          extraFields: form.extraFields.map((f) =>
                            f.label === field.label ? { ...f, ...value } : f
                          ),
                        }),
                      customDimensionKeyIds: form.customDimensionKeyIds,
                      dimensions,
                      adunits,
                    }}
                  />
                  <Button
                    variant="outline-primary"
                    className="mx-1"
                    size="sm"
                    onClick={() =>
                      setForm({
                        ...form,
                        extraFields: form.extraFields.map((f) =>
                          f.label === field.label
                            ? {
                                ...f,
                                conditions: [
                                  ...(f.conditions || []),
                                  {
                                    id: uuid(),
                                    filters: [],
                                    label: f.label,
                                    depend:
                                      options[f.label][
                                        Object.keys(options[f.label])[0]
                                      ],
                                    hasFilter: true,
                                  },
                                ],
                              }
                            : f
                        ),
                      })
                    }
                  >
                    ➕ 新增有條件的設定
                  </Button>
                  {(field.conditions || []).map((condition, index) => (
                    <React.Fragment key={condition.id}>
                      <Row className="mt-2">
                        <Col xs={2} />
                        <Col>
                          <h5>條件{index + 1}</h5>
                        </Col>
                        <Col xs={2}>
                          <FontAwesomeIcon
                            onClick={() => {
                              setForm({
                                ...form,
                                extraFields: form.extraFields.map((f) =>
                                  f.label === field.label
                                    ? {
                                        ...f,
                                        conditions: f.conditions.filter(
                                          (fc, i) => i !== index
                                        ),
                                      }
                                    : f
                                ),
                              })
                            }}
                            className="btn ms-3"
                            title="刪除"
                            icon={faTimes}
                          />
                        </Col>
                      </Row>
                      <Conditions
                        setting={{
                          field: {
                            ...condition,
                            active: field.active,
                          },
                          handleChange: (value) =>
                            setForm({
                              ...form,
                              extraFields: form.extraFields.map((f) =>
                                f.label === field.label
                                  ? {
                                      ...f,
                                      conditions: f.conditions.map((fd, i) =>
                                        i === index ? { ...fd, ...value } : fd
                                      ),
                                    }
                                  : f
                              ),
                            }),
                          customDimensionKeyIds: form.customDimensionKeyIds,
                          dimensions,
                          adunits,
                          lineItems,
                        }}
                      />
                    </React.Fragment>
                  ))}
                </Card.Body>
              </Card>
            ))}
          </Row>

          {records && (
            <ReportListSetting
              setting={{
                ...links.find((link) => link.report_id === linkId).setting,
                setLinkId,
                setshowsetting,
                handleEditLink: async (value) => {
                  await handleEditLink(linkId, {
                    ...links.find((link) => link.report_id === linkId).setting,
                    ...value,
                    form: {
                      ...form,
                      filters,
                    },
                  })
                  setshowsetting(3)
                },
                mockups: links.find((link) => link.report_id === linkId).setting
                  .mockups,
                data: records.filter((record) => checkFilters(record)),
                form,
                fieldLabelMap: {
                  impression: '計算曝光數', // 曝光
                  click: '計算點擊數', // 點擊
                  revenue: '計算收益', // 收益
                  click_rate: '計算點擊率', // 點擊率
                  'Dimension.AD_UNIT_ID': '廣告單元 ID',
                  'Dimension.AD_UNIT_NAME': '廣告單元名稱',
                  'Dimension.LINE_ITEM_ID': '廣告項目 ID',
                  'Dimension.LINE_ITEM_NAME': '委刊項', // 廣告項目名稱
                  'Dimension.DATE': '日期',
                  'Column.AD_SERVER_IMPRESSIONS': '廣告伺服器曝光', // 曝光次數
                  'Column.AD_SERVER_CLICKS': '廣告伺服器點擊', // 點擊次數
                  'Column.AD_SERVER_CTR': '廣告伺服器點擊率', // 點閱率
                  'Column.AD_SERVER_REVENUE': '收益',
                  'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS':
                    'AdX 曝光次數',
                  'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_CLICKS': 'AdX 點擊次數',
                  'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE': 'AdX 收益',
                  'Column.AD_EXCHANGE_TOTAL_REQUESTS': 'AdX 請求次數',
                  ...dimensions.reduce((prev, cur) => {
                    const isCustomTargetingKey = cur.name.includes(
                      'customTargetingKeys'
                    )
                    const isCustomField = cur.name.includes('customFields')

                    if (isCustomTargetingKey) {
                      return {
                        ...prev,
                        [`Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[${cur.id}]_VALUE`]:
                          cur.displayName,
                        [`Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[${cur.id}]_ID`]: `${cur.displayName}ID`,
                      }
                    }
                    if (isCustomField) {
                      return {
                        ...prev,
                        [`CF[${cur.id}]_Value`]: cur.displayName,
                      }
                    }
                    return prev
                  }, {}),
                },
              }}
            />
          )}
        </div>
      ) : (
        <>
          {!(downloadUrl && records) && (
            <div className="d-flex h-100 justify-content-center">
              <Spinner
                className="my-auto"
                animation="border"
                size="sm"
                style={{
                  animation: 'spinner-border 1.5s linear infinite',
                }}
              />
              <h5 className="text-dai fs-4 my-auto ms-2">資料載入中...</h5>
            </div>
          )}
          {downloadUrl && (
            <Alert variant="success" className="mt-3">
              {auth.authed ? '✅ 報表完成！' : '這是您的報表'}
              <br />
              {/* <a href={downloadUrl} target="_blank" rel="noreferrer">
                點此下載報表
              </a> */}
              {/* <br /> */}
              {auth.authed && (
                <>
                  <Button
                    className="ms-auto me-2 mt-2"
                    variant="outline-dai"
                    size="sm"
                    onClick={() => {
                      setshowsetting(1)
                      setLinkId('')
                    }}
                    disabled={loading}
                  >
                    返回列表
                  </Button>
                  <Button
                    onClick={() => {
                      setshowsetting(2)
                    }}
                    className="me-auto mt-2"
                    variant="outline-dai"
                    size="sm"
                  >
                    上一步
                  </Button>
                  {/* <Button
                    onClick={() => {
                      setshowsetting(1)
                    }}
                    className="me-auto mt-2"
                    variant="outline-dai"
                    size="sm"
                  >
                    重新設定
                  </Button> */}
                </>
              )}
            </Alert>
          )}
          {records && (
            <ReportList
              setting={{
                handleEditLink: async (value) => {
                  handleEditLink(linkId, {
                    ...links.find((link) => link.report_id === linkId).setting,
                    ...value,
                  })
                },
                data: records.filter((record) => checkFilters(record)),
                defaultRate: currencyTable[0].value,
                ...links.find((link) => link.report_id === linkId).setting,
                fieldLabelMap: {
                  AQUARIUM_IMPRESSION: '曝光',
                  AQUARIUM_REVENUE: '收益',
                  'Dimension.AD_UNIT_ID': '廣告單元 ID',
                  'Dimension.AD_UNIT_NAME': '廣告單元名稱',
                  'Dimension.LINE_ITEM_ID': '廣告項目 ID',
                  'Dimension.LINE_ITEM_NAME': '委刊項', // 廣告項目名稱
                  'Dimension.DATE': '日期',
                  'Column.AD_SERVER_IMPRESSIONS': '廣告伺服器曝光', // 曝光次數
                  'Column.AD_SERVER_CLICKS': '廣告伺服器點擊', // 點擊次數
                  'Column.AD_SERVER_CTR': '廣告伺服器點擊率', // 點閱率
                  'Column.AD_SERVER_REVENUE': '收益',
                  'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_IMPRESSIONS':
                    'AdX 曝光次數',
                  'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_CLICKS': 'AdX 點擊次數',
                  'Column.AD_EXCHANGE_LINE_ITEM_LEVEL_REVENUE': 'AdX 收益',
                  'Column.AD_EXCHANGE_TOTAL_REQUESTS': 'AdX 請求次數',
                  ...dimensions.reduce((prev, cur) => {
                    const isCustomTargetingKey = cur.name.includes(
                      'customTargetingKeys'
                    )
                    const isCustomField = cur.name.includes('customFields')

                    if (isCustomTargetingKey) {
                      return {
                        ...prev,
                        [`Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[${cur.id}]_VALUE`]:
                          cur.displayName,
                        [`Dimension.TOP_LEVEL_CUSTOM_TARGETING_KEY[${cur.id}]_ID`]: `${cur.displayName}ID`,
                      }
                    }
                    if (isCustomField) {
                      return {
                        ...prev,
                        [`CF[${cur.id}]_Value`]: cur.displayName,
                      }
                    }
                    return prev
                  }, {}),
                },
              }}
            />
          )}
        </>
      )}
    </div>
  ) : (
    <div className="p-5 h-100 d-flex flex-column">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <InputGroup style={{ maxWidth: '300px' }}>
          <Form.Control
            placeholder="搜尋名稱"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
        <Button onClick={() => handleAddLink()}>新增</Button>
      </div>

      <ListGroup className="overflow-auto" style={{ flex: 1 }}>
        {filtered.map((c, i) => (
          <ListGroup.Item key={i} className="d-flex py-3">
            <p className="my-auto">{c.setting.form.name}</p>
            <FontAwesomeIcon
              onClick={() => setLinkId(c.report_id)}
              className="btn ms-auto"
              title="編輯"
              icon={faEdit}
            />
            <FontAwesomeIcon
              onClick={async () => {
                const res = await apiServices.data({
                  path: `report/getLink/${c.report_id}`,
                  method: 'get',
                })
                window.open(`${window.origin}/insights/${res}`)
              }}
              className="btn ms-3"
              title="預覽"
              icon={faDisplay}
            />
            <FontAwesomeIcon
              onClick={async () => {
                const res = await apiServices.data({
                  path: `report/getLink/${c.report_id}`,
                  method: 'get',
                })
                const cb = navigator.clipboard
                cb.writeText(`${window.origin}/insights/${res}`)
                setToast({
                  show: true,
                  text: '已 複 製 連 結 到 剪 貼 簿',
                })
              }}
              className="btn ms-3"
              title="取得tag"
              icon={faLink}
            />
            <FontAwesomeIcon
              onClick={() =>
                setshowWarn({
                  show: true,
                  func: () => handleDeleteLink(c.report_id),
                })
              }
              className="btn ms-3"
              title="刪除"
              icon={faTrashAlt}
            />
          </ListGroup.Item>
        ))}
      </ListGroup>

      <Warn
        setting={{
          show: showWarn.show,
          handleClose: (value) => {
            if (value) showWarn.func()
            setshowWarn({
              show: false,
              func: () => {},
            })
          },
        }}
      />
    </div>
  )
}

Warn.propTypes = {
  setting: PropTypes.shape().isRequired,
}

Conditions.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default AdManagerReportForm
